import { queryFnNotificationWrapper } from '@ankr.com/utils/queryFnNotificationWrapper';
import { BaseQueryApi } from '@reduxjs/toolkit/query';

import { INotificationProps } from 'domains/notifications/store/notificationSlice';
import { NotificationActions } from 'domains/notifications/store/NotificationActions';
import { extractMessage } from 'modules/common/utils/extractError';
import { isAxiosAuthError } from 'modules/auth/utils/isAxiosAuthError';
import { isTFAError } from 'modules/tfa/utils/isTFAError';
import { isMetamaskInternalError } from 'modules/common/utils/isMetamaskInternalError';
import { isViemError } from 'modules/common/utils/isViemError';

import { getAxiosAccountingErrorMessage } from './getAxiosAccountingErrorMessage';
import { getParsedErrorMessage } from './getParsedErrorMessage';
import { isAxiosAccountEmailError } from './isAxiosAccountingEmailError';
import { isAxiosAccountingError } from './isAxiosAccountingError';
import { isAxiosPermissionError } from './isAxiosPermissionError';
import { isConnectionAborted } from './isConnectionAborted';
import { isCustomError } from './isCustomError';

const makeNotification = (
  error: unknown,
  dispatch: BaseQueryApi['dispatch'],
  notificationOptions?: Partial<INotificationProps>,
) => {
  let message = extractMessage(error);

  if (isAxiosPermissionError(error)) {
    message = extractMessage(error.response?.data, 'error.permission');
  }

  if (isAxiosAccountingError(error)) {
    message = getAxiosAccountingErrorMessage(error);
  }

  if (getParsedErrorMessage(error)) {
    message = getParsedErrorMessage(error);
  }

  dispatch(
    NotificationActions.showNotification({
      message,
      severity: 'error',
      ...(notificationOptions || {}),
    }),
  );
};

const shouldNotify = (error: unknown) => {
  return (
    !isConnectionAborted(error) &&
    !isAxiosAccountEmailError(error) &&
    !isTFAError(error) &&
    !isCustomError(error) &&
    !isMetamaskInternalError(error) &&
    !isAxiosAuthError(error) &&
    !isViemError(error)
  );
};

export const createNotifyingQueryFn = queryFnNotificationWrapper({
  onNotification({ api: { dispatch }, error }) {
    if (shouldNotify(error)) {
      makeNotification(error, dispatch);
    }
  },
});
